module.exports = {
  "$id": "otherRegister",
  "type": "object",
  "title": "护照及其他证件注册",
  "properties": {
    "loginName": {
      "title": "用户名",
      "type": "string",
      "format": "loginName"
    },
    "country": {
      "title": "国籍",
      "type": "string"
    },
    "password": {
      "title": "密码",
      "type": "string",
      "format": "newPassword"
    },
    "confirmPassword": {
      "title": "确认密码",
      "type": "string",
      "format": "newPassword",
      "const": {
        "$data": "1/password"
      }
    },
    "surname": {
      "title": "中文姓",
      "type": "string",
      "customValidate": "zhLastName"
    },
    "name": {
      "title": "中文名",
      "type": "string",
      "customValidate": "zhFirstName"
    },
    "engSurname": {
      "title": "英文姓",
      "type": "string",
      "customValidate": "enName"
    },
    "engName": {
      "title": "英文名",
      "type": "string",
      "customValidate": "enName"
    },
    "certType": {
      "title": "证件类型",
      "type": "string"
    },
    "certNo": {
      "title": "证件号",
      "type": "string",
      "customValidate": "certNo"
    },
    "birthDate": {
      "title": "出生日期",
      "type": "string",
      "format": "date"
    },
    "gender": {
      "title": "性别",
      "type": "string"
    },
    "phone": {
      "title": "手机号",
      "type": "string",
      "customValidate": "mobile"
    },
    "areaCode": {
      "title": "区位码",
      "type": "string"
    },
    "email": {
      "title": "邮箱",
      "type": "string",
      "format": "email"
    }
  },
  "if": {
    "properties": {
      "country": {
        "const": "CN"
      }
    }
  },
  "then": {
    "required": ["surname", "name"]
  },
  "required": [
    "loginName",
    "country",
    "password",
    "confirmPassword",
    "engSurname",
    "engName",
    "certType",
    "certNo",
    "birthDate",
    "phone"
  ],
  "errorMessage": {
    "loginName": {
      "message": "请输入用户名,长度6-40位",
      "required": "用户名不能为空"
    },
    "country": {
      "required": "请选择国籍"
    },
    "password": {
      "message": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "密码不能为空"
    },
    "confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "请再次输入密码"
    },
    "surname": {
      "required": "中文姓不能为空"
    },
    "name": {
      "required": "中文名不能为空"
    },
    "engSurname": {
      "message": "请输入正确的英文姓",
      "required": "英文姓不能为空"
    },
    "engName": {
      "message": "请输入正确的英文名",
      "required": "英文名不能为空"
    },
    "certType": {
      "required": "请选择证件类型"
    },
    "certNo": {
      // "message": "证件号不正确",
      "required": "请输入证件号"
    },
    "birthDate": {
      "required": "请选择出生日期"
    },
    "phone": {
      "required": "手机号码不能为空"
    }
  }
}
